import CameraCapture from "../components/CameraCapture";

function App() {

    return <CameraCapture/>;
}

export default App;